export const EDIT_METER_READINGS_URL_PARMS = {
  skipConfirmationView: 'skipConfirmationView'
}
